import config from '../../config/generated.json'

function getHeaderLogoPath(): string {
  return config.filePaths.logo.header
}

export default getHeaderLogoPath
